import "./Aplicativo.css";

import React from "react";

const Aplicativo = () => {
  const backgroundStyle = {
    backgroundImage: "url('section-app.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
  };

  return (
    <section className="app-section" style={backgroundStyle}>
      <div className="app-content">
        <button className="button-em-breve">APLICATIVO NO AR! 🚀</button>

        <h1 className="app-heading">
          Explore o aplicativo da <br /> <strong>Banda Brasil Papaya!</strong>
        </h1>

        <p className="app-intro">
          A Brasil Papaya está chegando com tudo pra deixar seus estudos musicais ainda mais incríveis!
          Desenvolvido pela Zebra Labs, o aplicativo oficial da banda vem recheado de ferramentas pra você arrasar na sua música.
        </p>

        <ul className="app-features">
          <li><strong>Afinador</strong></li>
          <li><strong>Metrônomo</strong></li>
          <li><strong>Decibelímetro</strong></li>
        </ul>

        <p className="app-cta">Cadastre-se e baixe gratuitamente:</p>

        <div className="app-download-buttons">
          <a
            href="https://apps.apple.com/br/app/brasil-papaya/id6745204195"
            target="_blank"
            rel="noopener noreferrer"
            className="store-button"
          >
            <img
              src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
              alt="Baixar na App Store"
            />
          </a>

          <a href="#" className="store-button">
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png"
              alt="Disponível no Google Play"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Aplicativo;